export function candidateBlockers(candidate) {
  const blockers = [];
  if (candidate.review_state !== 'APPROVED') blockers.push('review');
  if (candidate.checks_state !== 'SUCCESS') blockers.push('checks');
  if (candidate.qa_status !== 'PASSED') blockers.push('qaStatus');
  return blockers;
}
